import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  HostBinding,
  Input,
  QueryList
} from '@angular/core';

import { AccordionPanelComponent } from './panel/accordion-panel.component';

@Component({
  selector: 'pcs-accordion',
  styleUrls: ['./accordion.component.scss'],
  templateUrl: './accordion.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccordionComponent implements AfterContentInit {
  @Input() closeOthers = false;

  @HostBinding('class')
  @Input() accordionStyle = 'default';

  @ContentChildren(AccordionPanelComponent)
  private panels: QueryList<AccordionPanelComponent>;

  private selected = false;

  @HostBinding('class.accordion-group')
  private get accordionGroup() {
    return this.selected;
  }

  ngAfterContentInit(): void {
    if (this.closeOthers) {
      this.panels.forEach(panel => panel.panelState$
        .subscribe((openedPanel) =>
          this.closeOtherPanels(openedPanel)
        ));
      this.selected = true;
    }
  }

  closeOtherPanels(openedPanel) {
    this.panels.filter(panel => panel !== openedPanel)
      .forEach(panel => panel.isOpen = false);
  }

}
